const temporalLocale = {
  temporal: {
    nLastDays: "Aujourd'hui | {n} derniers jours",
    nLastMonths: "Ce mois ci | {n} derniers mois",
    fromTo: "Du {from} au {to}",
    datetime: "Le {date} à {time}",
  },
};

export type TemporalLocale = typeof temporalLocale;
export default temporalLocale;
